import { toast } from "react-toastify";

export const buildGoogleMapsUrl = ({
  latitude,
  longitude,
  address,
  name,
} = {}) => {
  const lat = Number(latitude);
  const lng = Number(longitude);
  if (
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    !(lat === 0 && lng === 0)
  ) {
    return `https://www.google.com/maps?q=${lat},${lng}`;
  }
  const query = [name, address].filter(Boolean).join(", ").trim();
  if (query) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
  }
  return "";
};

export const shareGarageLocation = async (garage, translate) => {
  const data = garage || {};
  const mapsUrl = buildGoogleMapsUrl(data);
  const t = typeof translate === "function" ? translate : (k) => k;

  if (!mapsUrl) {
    toast.error(t("locationNotAvailable") || "Location not available");
    return false;
  }

  const title = data.name || data.label || "Garage location";
  const text = [title, data.address].filter(Boolean).join(" — ");

  try {
    if (typeof navigator !== "undefined" && navigator.share) {
      await navigator.share({ title, text, url: mapsUrl });
      return true;
    }
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(mapsUrl);
      toast.success(t("mapsLinkCopied") || "Google Maps link copied");
      return true;
    }
    window.open(mapsUrl, "_blank", "noopener,noreferrer");
    return true;
  } catch (e) {
    if (e?.name === "AbortError") return false;
    try {
      await navigator.clipboard.writeText(mapsUrl);
      toast.success(t("mapsLinkCopied") || "Google Maps link copied");
      return true;
    } catch (err) {
      toast.error(t("unableToShareLocation") || "Unable to share location");
      return false;
    }
  }
};
